import { render, staticRenderFns } from "./RemittanceCard.vue?vue&type=template&id=17218726"
import script from "./RemittanceCard.vue?vue&type=script&lang=js"
export * from "./RemittanceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports